import { DeleteBajaAppTotalPass } from "../../reducers/totalPass";

/**
 * Baja de app TotalPass — mapStateToProps
 * Pantalla: /total-pass/baja-app
 */
export interface BajaAppStore extends DeleteBajaAppTotalPass {
  userId?: number | string;
}

export const bajaAppStore: (state) => BajaAppStore = state => {
  const totalPass = state.totalPass;
  const userContext = (state.user && state.user.userContext) || {};
  return {
    bajaAppResult: totalPass.bajaAppResult,
    postingBajaApp: totalPass.postingBajaApp,
    postingBajaAppError: totalPass.postingBajaAppError,
    userId:
      userContext.userId ||
      (userContext.account && userContext.account.userId) ||
      (userContext.profile && userContext.profile.userId)
  };
};
